


























































































































































































































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { membershipFields } from '@/config/subscriptions';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import FormProvider from '@shared/components/forms/form-provider.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import { Membership } from '@subscriptions/interfaces/subscription';
import EntityTableInput from '@shared/components/forms/inputs/entity-table-input/entity-table-input.vue';
import { Invoice } from '@accounting/interfaces/invoice';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import moment from 'moment';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import { invoiceDisplayFields } from '@/config/invoices';
import { paymentDisplayFields } from '@/config/payments';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import MembershipPaymentForm from './membership-payment-form.vue';
import { Payment } from '@accounting/interfaces/payment';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';

@Component({
  name: 'bpc-membership-form',
  components: {
    'bpc-form-provider': FormProvider,
    'bpc-input': Input,
    'bpc-input-group': InputGroup,
    'bpc-select': Select,
    'bpc-textarea': Textarea,
    'bpc-entity-table-input': EntityTableInput,
    'bpc-entity-select': EntitySelect,
    'bpc-content-wrapper': ContentWrapper,
    'bpc-display-field-badge': DisplayFieldBadge,
    'bpc-datepicker': Datepicker,
    'bpc-membership-payment-form': MembershipPaymentForm,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
  },
})
export default class MembershipForm extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
      manageSaveErrors(error): void;
    };
    softDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
  };
  // PROPS
  @Prop(Object) readonly initialData: Partial<Membership>;
  @Prop(Number) readonly modelId: number;
  @Prop({ type: Boolean, default: false }) readonly show: boolean;
  @Prop({ type: Boolean, default: true }) readonly showMembersField: boolean;
  @Prop({ type: Boolean, default: false }) readonly noFetchData: boolean;
  @Prop({ type: Boolean, default: false }) readonly bulkCreate: boolean;
  @Prop({ type: Boolean, default: false }) readonly bulkCreateFromContact: boolean;
  @Prop({ type: Boolean, default: false }) readonly showCancelButton: boolean;
  @Prop({ type: Boolean, default: false }) readonly showCategoryField: boolean;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly value: Membership;
  @Prop({
    type: String,
  })
  readonly cancelButtonsPortalTarget: string;

  @Prop({
    type: String,
  })
  readonly saveButtonsPortalTarget: string;
  // DATA

  dataLoaded: boolean = false;
  ticketsLoaded: boolean = false;
  tickets: Invoice[] = [];
  savingFields: boolean = false;
  showAddPaymentForm: boolean = false;
  selectedTicketToPay: Invoice = null;
  timestamp = moment().unix();
  paymentFormModel: Partial<Payment> = null;
  showPaymentDrawerSection: boolean = false;
  ticketOfPaymentToEdit = null;
  // Bulk soft delete modal (move to trash)
  showBulkMoveToTrashModal = false;

  // COMPUTED

  get formModel(): Membership {
    return this.value;
  }
  set formModel(value) {
    this.$emit('input', value);
  }

  get fieldsConfig() {
    return membershipFields;
  }

  get invoiceDisplayConfig() {
    return invoiceDisplayFields;
  }

  get paymentDisplayConfig() {
    return paymentDisplayFields;
  }

  get label() {
    return {
      labelAttributes: {
        for: 'test',
      },
      labelClass: {
        'mt-1 mb-0': true,
      },
    };
  }
  get noLabel() {
    return {
      showLabel: false,
      labelAttributes: {
        for: 'test',
      },
      labelClass: {
        'mt-1 mb-0': true,
      },
    };
  }
  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 px-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 px-2': true,
        },
      },
    };
  }
  get col3() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-3 px-2': true,
        },
      },
    };
  }
  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 px-2': true,
        },
      },
    };
  }

  get ticketFilters() {
    return [
      {
        filterField: 'membership_id',
        modelField: 'id',
        value: this.formModel.id,
      },
    ];
  }

  get currentTicketDueDate(): string {
    if (this.tickets.length) {
      return this.tickets[0].due_date;
    }
    return null;
  }

  get currentTicketTotalAmount(): number {
    if (this.tickets.length) {
      return this.tickets[0].total_amount;
    }
    return null;
  }

  get paymentFormActionButtonsPortalTarget() {
    return `payment-form-action-buttons-portal-target-${this.timestamp}`;
  }
  get paymentFormCancelButtonsPortalTarget() {
    return `payment-form-cancel-buttons-portal-target-${this.timestamp}`;
  }

  get editPaymentFormActionButtonsPortalTarget() {
    return `payment-form-action-buttons-portal-target-${this.timestamp}`;
  }
  get editPaymentFormCancelButtonsPortalTarget() {
    return `payment-form-cancel-buttons-portal-target-${this.timestamp}`;
  }

  get softDeleteConfirmationModalConfig(): ConfirmationModalConfig {
    const entityName = 'payment';
    return {
      id: entityName + '-soft-delete-modal',
      title: this.$t('global.modals.soft-delete.title', {
        entityName: this.$t('global.models.' + entityName + '.name'),
        entityPluralName: this.$t('global.models.' + entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + entityName + '.thisPluralName'),
      }),
      body: this.$t('global.modals.soft-delete.body', {
        entityName: this.$t('global.models.' + entityName + '.name'),
        entityPluralName: this.$t('global.models.' + entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + entityName + '.thisPluralName'),
      }) as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.move_to_trash') as string,
      acceptButtonVariant: 'danger',
    };
  }

  paymentDeletePath: string = `${this.$bpcApiRouteHelper.getEntityPath('membership')}/${
    this.formModel.id
  }/payments`;

  // LIFECYCLE
  // created(){}
  // updated(){}
  // destroyed(){}

  // METHODS
  onAddPayment(ticket) {
    this.selectedTicketToPay = ticket;
    this.showAddPaymentForm = true;
  }
  closeAddPaymentForm() {
    this.showAddPaymentForm = false;
  }
  closeEditPaymentForm() {
    this.showPaymentDrawerSection = false;
  }

  async onPaymentSaved(event) {
    this.$emit('payments-saved', event);
    await this.getMembershipTickets();
    this.closeAddPaymentForm();
  }

  prepareToSave(membership: Membership) {
    const newMembership = membership;
    if (!this.bulkCreate) {
      this.$set(newMembership, 'member_ids', [membership.contact_id]);
    }
    this.$set(newMembership, 'membership_category_id', membership.subscription_category_id);
    return newMembership;
  }
  async updateFields() {
    this.savingFields = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('membership');
    const path = `${basePath}/${this.formModel.id}/update-fields`;
    const body = {
      status: this.formModel.status,
      comment: this.formModel.comment,
    };

    if (this.formModel.price) {
      this.$set(body, 'price', this.formModel.price);
    }

    if (this.currentTicketDueDate !== this.formModel.ticket_due_date) {
      this.$set(body, 'ticket_due_date', this.formModel.ticket_due_date);
    }

    try {
      await this.$bpcApi.patch(path, body).toPromise();
      this.$emit('entity-saved', this.formModel);
      this.savingFields = false;
      this.onClose();
    } catch (error) {
      this.$refs.formProvider.manageSaveErrors(error);
      this.onEntityErrorSaving(error);
      this.savingFields = false;
    }
  }
  async getMembershipTickets() {
    if (this.formModel.id) {
      this.ticketsLoaded = false;
      const basePath = this.$bpcApiRouteHelper.getEntityPath('membership');
      const path = `${basePath}/${this.formModel.id}/tickets`;
      try {
        const res = await this.$bpcApi.get(path).toPromise();
        this.tickets = res.data;
        this.formModel.ticket_due_date = this.currentTicketDueDate;
        this.ticketsLoaded = true;
      } catch (error) {
        this.$bpcMessage.showErrorMessage({
          text: 'subscriptions.membership_error_loading_tickets',
        });
        this.ticketsLoaded = false;
      }
    }
  }

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
    this.onClose();
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({ text: 'core.superadmin_form_update_errors' });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }

  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }

  onClose() {
    this.$emit('close');
  }

  clickOnEditPayment(payment, ticket) {
    this.paymentFormModel = payment;
    this.ticketOfPaymentToEdit = ticket;
    this.showPaymentDrawerSection = true;
  }

  clickOnSoftDelete(data) {
    this.$refs.softDeleteConfirmationModal.onOpenModal(data.id);
  }

  async onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.$emit('payments-saved', event);
    await this.getMembershipTickets();
  }

  paymentCanBeEdited(payment) {
    return payment.manual || (payment.origin && payment.origin === 'manual');
  }
  paymentCanBeDeleted(payment) {
    return payment.manual || (payment.origin && payment.origin === 'manual');
  }

  formatAmount(value: number) {
    return value.toFixed(2).replace('.', ',') + ' €';
  }

  public formatDate(date): string {
    if (date) {
      return moment(String(date)).format('DD/MM/YYYY');
    }
  }

  // WATCHERS
}
